/* eslint-disable import/prefer-default-export */
import GerepAPI from '../../api/gerep/GerepAPI'

export const getConfiguration = (token) => {
	return GerepAPI.get('/configuration', null, token)
}
